import moment from "moment/moment";

export const getStartTime = (time, locale) => {
    const today = moment().startOf('day');
    const isToday = time.isSame(today, 'day');

    const todayTranslation = {
        en: "Today",
        es: "Hoy",
        fr: "Auj."
    };

    if (isToday) {
        return `${todayTranslation[locale] || todayTranslation.en}${locale !== "fr"? ",":""} ${time.format('h:mm A')}`;
    } else {
        return time.format('MMM D, h:mm A');
    }
}